import { FinancialPendingDTO } from "../dtos";
import { FinancialPending, FinancialPendingStatus } from "~/application/types";

export const mapFinancialPendingDTO = (dto: FinancialPendingDTO): FinancialPending => {
  return {
    id: dto.uuid,
    amount: dto.amount,
    status: dto.status as FinancialPendingStatus,
    expenseReport: dto.expense_report
      ? {
        id: dto.expense_report.uuid,
        orderId: dto.expense_report.order_uuid,
        title: dto.expense_report.title,
        reportNumber: dto.expense_report.report_number,
      }
      : undefined,
    issuer: dto.issuer
      ? {
        id: dto.issuer.uuid,
        name: dto.issuer.name,
      }
      : undefined,
    receipt: dto.receipt
      ? {
        id: dto.receipt.uuid,
        fileUrl: dto.receipt.file_url,
        originalName: dto.receipt.original_name,
        format: dto.receipt.format,
        sizeBytes: dto.receipt.size_bytes,
      }
      : dto.receipt_url
        ? {
          id: "",
          fileUrl: dto.receipt_url,
          originalName: "Comprovante",
          format: "",
          sizeBytes: 0,
        }
        : undefined,
    observation: dto.observation,
    rejectionReason: dto.rejection_reason,
    createdAt: new Date(dto.created_at),
  };
};
